import {
  GET_TERRITORY_COMPARE_DATA_UNIVERSE,
  GET_DASHBOARDS_COUNT,
  GET_JOB_FOLDERS,
  GET_JOBS_WITH_FOLDERS,
  GET_LIST_WORDSPACE_JOB_PAGINATED,
  GET_RECENTS_DASHBOARDS,
  CREATE_TERRITORY_ANALYSIS,
  CREATE_WORKSPACE_JOB_DEMAND_SPACES,
  DUPLICATE_WORKSPACE_DASHBOARD,
  GET_JOB_EXTERNAL_FOLDERS,
  CREATE_JOB_EXTERNAL_FOLDER,
  DELETE_JOB_EXTERNAL_FOLDER,
  EDIT_JOB_EXTERNAL_FOLDER,
  GET_JOB_EXTERNAL_FOLDER,
  ADD_DASHBOARD_TO_FOLDER,
  CREATE_JOB_CSV_EXPORT,
  GET_DASHBOARD_TERRITORIES,
} from './operations'
import type { DashboardQueriesMap, TDashboardMutationsMap } from './types'

export const GRAPH_DASHBOARD_QUERIES: DashboardQueriesMap = {
  getListWorkspaceJobPaginated: GET_LIST_WORDSPACE_JOB_PAGINATED,
  getRecentsDashboards: GET_RECENTS_DASHBOARDS,
  getWorkspaceJobsCount: GET_DASHBOARDS_COUNT,
  getWorkspaceJobsWithFoldersPaginated: GET_JOBS_WITH_FOLDERS,
  getJobFolders: GET_JOB_FOLDERS,
  getTerritoryCompareDataUniverse: GET_TERRITORY_COMPARE_DATA_UNIVERSE,
  getJobExternalFolders: GET_JOB_EXTERNAL_FOLDERS,
  getJobExternalFolder: GET_JOB_EXTERNAL_FOLDER,
  GET_DASHBOARD_TERRITORIES,
}

export const GRAPHQL_DASHBOARD_MUTATIONS: TDashboardMutationsMap = {
  createTerritoryAnalysis: CREATE_TERRITORY_ANALYSIS,
  createWorkspaceJobDemandSpaces: CREATE_WORKSPACE_JOB_DEMAND_SPACES,
  duplicateWorkspaceDashboard: DUPLICATE_WORKSPACE_DASHBOARD,
  createJobExternalFolder: CREATE_JOB_EXTERNAL_FOLDER,
  deleteJobExternalFolder: DELETE_JOB_EXTERNAL_FOLDER,
  editJobExternalFolder: EDIT_JOB_EXTERNAL_FOLDER,
  createWorkspaceJobFolderRelations: ADD_DASHBOARD_TO_FOLDER,
  createJobCSVExport: CREATE_JOB_CSV_EXPORT,
}
